import React, { useState, useEffect } from 'react';
import { Box, Grid, Button, useMediaQuery } from '@mui/material';
import {
  PageContainer,
  FilterPod,
  Empty,
  LoadingPage,
  PaginationComponenets,
  Icons
} from 'components';
import { useNavigate } from 'react-router-dom';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { generateData } from './components/Columns';
import SubsetServices from '../../services/SubsetServices';
import InitFilters from './constants/InitFiltering';
import { useStyles } from './style';
import { BranchItem } from './components';
import useCustomHook from '../../hooks';
import FilterButton from 'components/FilterPod/FilterButton';
let filterTemp = []

export default function BranchList() {
  //-- STATES --//
  const {
    loading,
    setLoading,
    setFilterParams,
    size,
    page,
    currentPage,
    setCurrentPage,
    BranchDetails, setBranchDetails,
    totalCount, setTotoalCount
  } = useCustomHook();

  const navigate = useNavigate();
  const matches = useMediaQuery('(max-width:940px)');

  /**
   * لیست اکشن ها رو برمیگرداند . به ازای هر اکشن ، درصورتیکه دسترسی داشته باشد ترو و دسترسی نداشته باشد فالز است
   */
  const actionsList =
    getDynamicObjectAction([
      'branchListOperationAction',
      'branchListDetailAction',
      'branchListTable',
      'branchListTransferAction',
      'branchAddNew',
      'branchListChargeBtn',
      'branchListReportBtn'
    ]);
  //--HOOKS--//
  const classes = useStyles();
  const [filters, setFilters] = useState(InitFilters());
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  useEffect(() => {
    filterTemp = []
    getBranchesList();
    paginationOnChange({
      page: currentPage === 0 ? 1 : currentPage,
      pageSize: 12,
      pageNumber: currentPage === 0 ? 0 : currentPage - 1,
      changeData: true,
    });

  }, [currentPage]);
  //--API REQUESTS--//
  const getBranchesList = async (query) => {
    try {
      setLoading(true);
      let filter = toFilterVOS([...filterTemp]);
      let queries = filterVOStoQueryStr(filter);

      let params = {
        offset: currentPage === 0 ? 0 : ((currentPage - 1) * 12),
        size: query ? query?.pageSize : size,
        ...queries,
      };

      const data = {
        filterVOS: [],
        parentParams: [],
        orderByElementVOS: [],
      };

      setFilterParams({ data, params });

      const res = await SubsetServices.getBranch(params);

      let list = [];

      list = generateData(res?.result, {
        page: query ? query?.pageNumber : page,
        pageSize: query?.pageSize || size,
      });
      setTotoalCount(res?.count);
      setBranchDetails(list)
      setLoading(false);

      let d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d;
    } catch (error) {
      setLoading(false);

      return {
        data: [],
        page: query ? query?.pageNumber : page,
        totalCount: 0,
      };
    }
  };

  // تابع برای تغییر وضعیت انتخاب همه ردیف‌ها
  const paginationOnChange = async (param) => {
    if (param?.changeData) {
      // صفحه جاری در این بخش ست میش
      setCurrentPage(param?.page == 0 ? 1 : param?.page);

    }
  };

  //-- OTHER FUNCTIONS --//
  const onFiltersChange = async (newFilters) => {
    setFilters(newFilters);
    filterTemp = newFilters
    if (currentPage !== 1) {
      setCurrentPage(1)
    } else {
      getBranchesList();

    }


  };

  const hint = 'در این بخش مالک کسب و کار میتواند لیست شعبه های ایجاد شده را مشاهده و ویرایش کند.';

  return (
    <PageContainer
      title="لیست شعبه ها"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.BRANCH_LIST}
      className={classes.root}
    >
      { // چک میکنه توی acl  دسترسی داده شده به این جدول یا خیر
        actionsList['branchListTable'] && (
          <>
            <Grid item xs={12}>
              <Box display='flex' justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16, gap: matches ? '5px' : '0' }} className={classes.btnActions}>

                <FilterButton
                  setOpenFilterDialog={setOpenFilterDialog}
                  filters={filters}
                />
                { // اگر بهش این دسترسی داده شده باشه
                  actionsList['branchAddNew'] &&
                  <Button
                    className={classes.cardHeaderButton}
                    onClick={() => navigate('/Branch/Add')}
                    color="primary"
                    startIcon={<Icons icon='plusCircle' color='#fff' size='18' />}
                    variant="contained"
                  >
                    ایجاد شعبه
                  </Button>
                }
              </Box>
              <Box>
                <FilterPod
                  filters={filters}
                  onChange={onFiltersChange}
                  openFilterDialog={openFilterDialog}
                  setOpenFilterDialog={setOpenFilterDialog}
                  handleCloseFilterDialog={handleCloseFilterDialog}
                />
              </Box>
            </Grid>
            {loading ? <LoadingPage /> : null}
            {BranchDetails?.length === 0 && !loading ? <Empty /> : null}
            <Grid container spacing={2}>
              {!loading && BranchDetails?.length !== 0
                ? (BranchDetails.map((item, k) =>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <BranchItem
                      data={item}
                      dataGuild={BranchDetails}
                      setBranchDetails={setBranchDetails}
                      accDetails={BranchDetails}
                      key={k}
                      itemKey={k}
                      refreshList={getBranchesList}
                      actionsList={actionsList}
                      loading={loading}
                    />
                  </Grid>
                )
                )
                : null}
            </Grid>
            {!loading && BranchDetails?.length > 0 ? (
              <Grid justifyContent="center" container style={{ marginTop: 16 }}>
                <PaginationComponenets
                  itemsPerPage={12}
                  currentPage={currentPage}
                  pageCount={totalCount}
                  onChange={paginationOnChange}
                  removePrePage={true}
                />
              </Grid>
            ) : null}
          </>
        )}

    </PageContainer>
  );
}
